import { animate, stagger } from 'motion';
import { setupLinkHoverAnimations } from '../utils/linkAnimations';

/**
 * Initialize footer animations using the Motion library
 */
export function initFooterAnimations() {
  const footerLinks = document.querySelectorAll('.footer-link');

  // Don't proceed if there are no footer links
  if (footerLinks.length === 0) return;

  // Set up hover animations for footer links with JavaScript-based circle animations
  setupLinkHoverAnimations(footerLinks, { circleSize: '40px' });

}

export default initFooterAnimations;
